import { Stack } from '@mui/material';

import { BlockValueTemplateField } from '../../../ConfigFields/CodeMirror/FlowTemplate';

export function DocumentPacketGeneratorConfig() {
  return (
    <Stack spacing={2} sx={{ marginLeft: 6 }}>
      <BlockValueTemplateField
        fieldName="config.tools.config.documentPacketGenerator.relevantDocuments"
        label="Relevant Documents"
        helperText="List of documents objects for inclusion in the packet. Each document needs a documentId; metadata (date, type, title, source) is optional but recommended. Example: {{sidekickContext.data.document}}"
      />
      <BlockValueTemplateField
        fieldName="config.tools.config.documentPacketGenerator.preGeneratedPacket"
        label="Pre-generated Packet (optional)"
        helperText="File reference string (e.g. document:uuid) to an already-assembled PDF packet. Shows as a download button. Example: {{generateDocument.data.fileReference}}"
      />
    </Stack>
  );
}
